<template>
  <div class="row" v-if="this.subscriptions.length > 0">
    <h5>Subscriptions linked with the Email</h5>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>GOFAR Subscription ID</th>
          <th>Chargebee ID</th>
          <th>Chargebee E-mail</th>
          <th>GOFAR Subscription Status</th>
          <th>Device Serial Number</th>
          <th>Due Invoices</th>
          <th>GOFAR User ID</th>
          <th>GOFAR Email</th>
          <th>GOFAR Vehicle ID</th>
          <th>Make</th>
          <th>Model</th>
          <th>Year</th>
          <th>Vehicle Status</th>
          <th>Vehicles</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in subscriptions" :key="row.id" style="line-height: 35px;">
          <td>{{ row.subscriptionid }}</td>
          
          <td>
            <a :href="`https://gofar.chargebee.com/d/subscriptions/${row.chargebeesubscriptionid}`"
                  target="_blank"
                  >{{ row.chargebeesubscriptionid }}</a></td>
          <td>{{ row.chargebeecustomeremail }}</td>
          <td>{{ row.subscriptionstatus }}</td>
          <td>{{ row.deviceserialnumber }}</td>
          <td>{{ row.dueinvoicescount }}</td>
          <td>{{ row.userid }}</td>
          <td>{{ row.email }}</td>
          <td>{{ row.vehicleid }}</td>
          <td>{{ row.make }}</td>
          <td>{{ row.model }}</td>
          <td>{{ row.year }}</td>
          <td>{{ row.isvehicleactive }}</td>
          <td><a class="btn btn-outline-secondary" :href="`/admin/user/${row.userid}/vehicles`" target="_blank"><i class="bi bi-car-front-fill"></i></a></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'UserSubscriptionsTabular',
  props: {
    subscriptions: []
  },
  methods: {
  }
}
</script>